import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { Button } from './ui/button'

const NAV_LINKS = [
  { to: '/plays', label: 'Plays' },
  { to: '/diary', label: 'Diary' },
  { to: '/want-to-watch', label: 'Want to watch' },
  { to: '/profile', label: 'Profile' },
]

export function NavBar() {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()
  const [menuOpen, setMenuOpen] = useState(false)

  const handleSignOut = async () => {
    setMenuOpen(false)
    await signOut()
    navigate('/login')
  }

  return (
    <header className="relative border-b border-stone-800 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link
            to="/"
            className="font-serif text-xl font-semibold tracking-tight hover:text-stone-300 transition-colors"
          >
            Groundling
          </Link>
          {user && (
            <nav className="hidden md:flex items-center gap-6">
              {NAV_LINKS.map(({ to, label }) => (
                <Link
                  key={to}
                  to={to}
                  className="text-sm text-stone-400 hover:text-amber-400 transition-colors"
                >
                  {label}
                </Link>
              ))}
            </nav>
          )}
        </div>

        {user && (
          <div className="flex items-center gap-4">
            <span className="hidden md:block text-sm text-stone-500">{user.email}</span>
            <Button
              variant="ghost"
              onClick={handleSignOut}
              className="hidden md:inline-flex text-sm text-stone-400 hover:text-stone-200"
            >
              Log out
            </Button>
            <button
              className="md:hidden p-1 text-stone-400 hover:text-stone-200 transition-colors"
              onClick={() => setMenuOpen(open => !open)}
              aria-label="Toggle menu"
            >
              {menuOpen ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        )}
      </div>

      {user && menuOpen && (
        <nav className="md:hidden absolute top-full left-0 right-0 z-50 bg-stone-900 border-b border-stone-800 px-6 py-4 flex flex-col gap-4">
          {NAV_LINKS.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className="text-sm text-stone-400 hover:text-amber-400 transition-colors"
              onClick={() => setMenuOpen(false)}
            >
              {label}
            </Link>
          ))}
          <div className="border-t border-stone-800 pt-4 flex items-center justify-between">
            <span className="text-sm text-stone-500">{user.email}</span>
            <Button
              variant="ghost"
              onClick={handleSignOut}
              className="text-sm text-stone-400 hover:text-stone-200"
            >
              Log out
            </Button>
          </div>
        </nav>
      )}
    </header>
  )
}
